import { Component } from '@angular/core';

@Component({
  selector: 'slotcom-divider',
  template: '',
  styleUrls: ['./divider.component.scss'],
  standalone: true,
})
export class DividerComponent {}
